<template>
  <div>
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      stripePayment: {},
    };
  },
  mounted: function () {
    var aux = this;
    fetch(
      "https://api.flordeazahar.mx/stripe_retrieve_payment.php?payment_id=" +
        this.$route.query.payment_intent
    )
      .then((res) => res.json())
      .then((res) => (this.stripePayment = res))
      .then(() => {
        if (this.stripePayment.status == "succeeded") {
          fetch(
            "https://flordeazaharcms.actstudio.xyz/api/collections/save/Pedidos?token=bd38a532024ddfd195a5fdefd8eb98",
            {
              method: "post",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                data: {
                  _id: this.stripePayment.metadata.order_id,
                  tipo_pago: "Stripe",
                  estatus: "Pagado",
                },
              }),
            }
          ).then(function () {
            fetch(
              "https://api.flordeazahar.mx/correo_venta.php?referencia=" +
                aux.stripePayment.metadata.order_id
            ).then(function (res_2) {
              aux.$router.push(
                "/pedido/" + aux.stripePayment.metadata.order_id
              );
            });
          });
        }
      });
  },
};
</script>